const ITEMS = [
    { text: "Every night", script: false },
    { text: "every tide", script: true },
    { text: "The river, returned", script: false },
    { text: "country, cared for", script: true },
    { text: "The catch, accounted", script: false },
    { text: "dawn after dawn", script: true },
];

function Separator() {
    return (
        <svg viewBox="0 0 24 8" className="w-6 h-2 shrink-0 text-sky-200/50" fill="none" aria-hidden="true">
            <path
                d="M1 4 C 5 0.5, 8 7.5, 12 4 C 16 0.5, 19 7.5, 23 4"
                stroke="currentColor"
                strokeWidth="1.4"
                strokeLinecap="round"
            />
        </svg>
    );
}

function Row() {
    return (
        <div className="flex items-center gap-10 pr-10">
            {ITEMS.map((item, i) =>
                item.script ? (
                    <span key={i} className="flex items-center gap-10">
                        <span className="font-script text-3xl text-emerald-300/80 whitespace-nowrap">{item.text}</span>
                        <Separator />
                    </span>
                ) : (
                    <span key={i} className="flex items-center gap-10">
                        <span className="font-display italic font-semibold text-xl tracking-[0.18em] uppercase text-slate-300 whitespace-nowrap">
                            {item.text}
                        </span>
                        <Separator />
                    </span>
                )
            )}
        </div>
    );
}

export default function Marquee() {
    return (
        <div className="relative overflow-hidden border-y border-[#12283C] bg-[#020D18] py-5" data-testid="marquee" aria-hidden="true">
            <div className="marquee-track flex w-max items-center hover:[animation-play-state:paused]">
                <Row />
                <Row />
            </div>
            <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#020D18] to-transparent pointer-events-none" />
            <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#020D18] to-transparent pointer-events-none" />
        </div>
    );
}
